import { Modal } from 'react-responsive-modal';
import { Box, Grid, Typography } from '@mui/material';
import DateTimePickerField from '../../components/general/fields/dateTimePickerField';
import dayjs from 'dayjs';
import ButtonGeneral from '../../components/general/buttons/buttonGeneral';
import SearchIcon from '@mui/icons-material/Search';
import Close from '@mui/icons-material/Close';

type Props = {
    open: boolean;
    onClose: (value: boolean) => void;
    formik: any;
};

const ModalFilters = ({ open, onClose, formik }: Props) => {
    const handleClean = () => {
        formik.setFieldValue('startDate', null);
        formik.setFieldValue('endDate', null);
        formik.setFieldValue('responseStartDate', null);
        formik.setFieldValue('responseEndDate', null);
    };

    const handleClose = () => {
        onClose(false);
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            animationDuration={0}
            styles={{ modal: { maxWidth: '500px', minWidth: '40%' } }}
        >
            <Box component="form" onSubmit={formik.handleSubmit}>
                <Typography
                    color="primary"
                    component="h3"
                    sx={{ fontSize: { lg: 27, xs: 23 }, mt: 1.5 }}
                >
                    Filtros
                </Typography>
                <hr />
                <Box mt={3} px={1}>
                    <Typography
                        sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: '#666',
                            mb: 2,
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                        }}
                    >
                        Fecha de Creación
                    </Typography>
                    <Grid
                        container
                        spacing={{ xs: 1, md: 1 }}
                        columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                    >
                        <Grid item xs={12} md={6}>
                            <DateTimePickerField
                                label="Fecha inicio"
                                name="startDate"
                                size="small"
                                required
                                value={formik.values.startDate}
                                touched={formik.touched.startDate}
                                errors={formik.errors.startDate}
                                onChange={(value) =>
                                    formik.setFieldValue(
                                        'startDate',
                                        value,
                                        true
                                    )
                                }
                                disableFuture
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <DateTimePickerField
                                label="Fecha fin"
                                name="endDate"
                                size="small"
                                required
                                value={formik.values.endDate}
                                touched={formik.touched.endDate}
                                errors={formik.errors.endDate}
                                onChange={(value) =>
                                    formik.setFieldValue('endDate', value, true)
                                }
                                disableFuture
                                minDate={dayjs(formik.values.startDate)}
                            />
                        </Grid>
                    </Grid>

                    <Typography
                        sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: '#666',
                            mb: 2,
                            mt: 3,
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                        }}
                    >
                        Fecha de Respuesta
                    </Typography>
                    <Grid
                        container
                        spacing={{ xs: 1, md: 1 }}
                        columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                    >
                        <Grid item xs={12} md={6}>
                            <DateTimePickerField
                                label="Fecha inicio (Encuesta)"
                                name="responseStartDate"
                                size="small"
                                required
                                value={formik.values.responseStartDate}
                                touched={formik.touched.responseStartDate}
                                errors={formik.errors.responseStartDate}
                                onChange={(value) =>
                                    formik.setFieldValue(
                                        'responseStartDate',
                                        value,
                                        true
                                    )
                                }
                                disableFuture
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <DateTimePickerField
                                label="Fecha fin (Encuesta)"
                                name="responseEndDate"
                                size="small"
                                required
                                value={formik.values.responseEndDate}
                                touched={formik.touched.responseEndDate}
                                errors={formik.errors.responseEndDate}
                                onChange={(value) =>
                                    formik.setFieldValue(
                                        'responseEndDate',
                                        value,
                                        true
                                    )
                                }
                                disableFuture
                                minDate={dayjs(formik.values.responseStartDate)}
                            />
                        </Grid>
                        <Grid item xs={12} mt={1} sx={{ textAlign: 'right' }}>
                            <ButtonGeneral
                                title="Buscar"
                                onClick={formik.handleSubmit}
                                startIcon={<SearchIcon />}
                                sx={{ mr: 1 }}
                            />
                            <ButtonGeneral
                                title="Limpiar"
                                onClick={handleClean}
                                type="button"
                                startIcon={<Close />}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Modal>
    );
};
export default ModalFilters;
